import { UserMessages } from '../api';

export const fullMessageWithCTA: UserMessages = {
  inAppMessages: [
    {
      messageId: 'eL7Wrb0njSaxxmc9K2gsjuGudVLQ8rslKe1HmMLn04qr',
      content: {
        html: '<html>\n<head>\n\t<title></title>\n</head>\n<body data-new-gr-c-s-loaded="14.997.0">\n<h3>Test message2</h3>\n\n<p>lorem ipsum dolor sit amet<br />\n&nbsp;</p>\n<a href="action://closeMessage" style="display: none">Close</a></body>\n</html>\n',
        payload: {
          target: '/',
          author: 'Suzie',
          authorAvatar: 'https://unsplash.it/100/100',
          cta: 'Read more',
          ctaTarget: 'https://insights.hotjar.com/mouse',
        },
        inAppDisplaySettings: {
          top: { percentage: 0 },
          right: { percentage: 0 },
          bottom: { percentage: 0 },
          left: { percentage: 0 },
        },
      },
    },
  ],
};

export const simpleMessageWithoutCTA: UserMessages = {
  inAppMessages: [
    {
      messageId: 'aM7Wrb0njSaxxmc9K2gsjuGudVLQ8rslKe1HmMLn04aa',
      content: {
        html: '<html>\n<head>\n\t<title></title>\n</head>\n<body>\n<h3>Test Message with no CTA</h3>\n\n<p>lorem ipsum dolor sit amet<br />\n&nbsp;</p>\n<a href="action://closeMessage" style="display: none">Close</a></body>\n</html>\n',
        payload: {
          target: '/',
          author: 'Luigi',
          authorAvatar: 'https://unsplash.it/200/200',
          // cta: none
        },
        inAppDisplaySettings: {
          top: { percentage: 0 },
          right: { percentage: 0 },
          bottom: { percentage: 0 },
          left: { percentage: 0 },
        },
      },
    },
  ],
};

export const simpleMessageWithShowOnceOption: UserMessages = {
  inAppMessages: [
    {
      messageId: 'aM7Wrb0njSaxxmc9K2gsjuGudVLQ8rslKe1HmMLn04aa',
      content: {
        html: '<html>\n<head>\n\t<title></title>\n</head>\n<body>\n<h3>Show Once Test Message</h3>\n\n<p>lorem ipsum dolor sit amet<br />\n&nbsp;</p>\n<a href="action://closeMessage" style="display: none">Close</a></body>\n</html>\n',
        payload: {
          target: '/',
          author: 'Luigi',
          authorAvatar: 'https://unsplash.it/200/200',
          showOnce: true,
          // cta: none
        },
        inAppDisplaySettings: {
          top: { percentage: 0 },
          right: { percentage: 0 },
          bottom: { percentage: 0 },
          left: { percentage: 0 },
        },
      },
    },
  ],
};
